"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memberInitials = exports.isMember = exports.isSystemMember = exports.memberIsVisible = void 0;
const types_1 = require("@smartsuite/types");
const status_1 = require("./status");
function memberIsVisible(member) {
    const status = (0, status_1.getMemberOrTeamStatus)(member);
    return (!isSystemMember(member) &&
        (status.value === types_1.MemberStatuses.active ||
            status.value === types_1.MemberStatuses.invited));
}
exports.memberIsVisible = memberIsVisible;
function isSystemMember(member) {
    return member.role === types_1.MemberRoles.system;
}
exports.isSystemMember = isSystemMember;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isMember(arg) {
    if (typeof arg !== "object" || arg === null) {
        return false;
    }
    if (!arg.application_slug) {
        return "email" in arg && "full_name" in arg;
    }
    return arg.application_slug === types_1.MEMBERS_APP_SLUG;
}
exports.isMember = isMember;
function memberInitials(member) {
    var _a, _b, _c, _d;
    if (isMember(member)) {
        const firstInitial = ((_b = (_a = member.full_name) === null || _a === void 0 ? void 0 : _a.first_name) === null || _b === void 0 ? void 0 : _b.split(" ")[0][0]) || "";
        const secondInitial = ((_d = (_c = member.full_name) === null || _c === void 0 ? void 0 : _c.last_name) === null || _d === void 0 ? void 0 : _d.split(" ")[0][0]) || "";
        return (member === null || member === void 0 ? void 0 : member.full_name) ? `${firstInitial}${secondInitial}` : "";
    }
    else {
        const fullName = member.first_name + member.last_name;
        const firstInitial = member.first_name.split(" ")[0][0] || "";
        const secondInitial = member.last_name.split(" ")[0][0] || "";
        return fullName ? `${firstInitial}${secondInitial}` : "";
    }
}
exports.memberInitials = memberInitials;
